import { useEffect, useState } from 'react';
import axiosInstance from '@/lib/axiosInstance';
import StaticValue from '@/lib/StaticValue';

export const useOrgLogo = () => {
    const [orgLogo, setOrgLogo] = useState<string | null>(null);
    const [orgName, setOrgName] = useState<string | null>(null);
    const [socialMedia, setSocialMedia] = useState({
        facebookUrl: null as string | null,
        facebookEnabled: false,
        twitterUrl: null as string | null,
        twitterEnabled: false,
        instagramUrl: null as string | null,
        instagramEnabled: false,
        linkedinUrl: null as string | null,
        linkedinEnabled: false,
    });
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const defaultLogo = "/images/hart-clg-new-logo.png";

    useEffect(() => {
        const fetchOrgLogo = async () => {
            setIsLoading(true);
            try {
                const response = await axiosInstance.get('api/org-info/logo');
                const data = response?.data?.data || {};
                if (data?.logo) {
                    setOrgLogo(`${StaticValue.baseURL}/${data.logo}`);
                } else {
                    setOrgLogo(null);
                }
                setOrgName(data?.name || null);
                setSocialMedia({
                    facebookUrl: data?.facebookUrl || null,
                    facebookEnabled: data?.facebookEnabled || false,
                    twitterUrl: data?.twitterUrl || null,
                    twitterEnabled: data?.twitterEnabled || false,
                    instagramUrl: data?.instagramUrl || null,
                    instagramEnabled: data?.instagramEnabled || false,
                    linkedinUrl: data?.linkedinUrl || null,
                    linkedinEnabled: data?.linkedinEnabled || false,
                });
            } catch (error) {
                console.error('Error fetching organization logo:', error);
                setOrgLogo(null);
                setOrgName(null);
                setSocialMedia({
                    facebookUrl: null,
                    facebookEnabled: false,
                    twitterUrl: null,
                    twitterEnabled: false,
                    instagramUrl: null,
                    instagramEnabled: false,
                    linkedinUrl: null,
                    linkedinEnabled: false,
                });
            } finally {
                setIsLoading(false);
            }
        };
        fetchOrgLogo();
    }, []);

    return { 
        logo: orgLogo || defaultLogo, 
        name: orgName || 'Hart College', 
        socialMedia,
        isLoading 
    };
};

